export default "__VITE_ASSET__Dfeph4n8__"